// extracted by mini-css-extract-plugin
module.exports = {"languageSelector":"LanguageSelector_languageSelector__3FnZi","mobileselector":"LanguageSelector_mobileselector__2Z0-G"};